const DEFAULT_MASTER_API_PATH = '/api/v1';
const DEFAULT_MASTER_HOST = 'http://localhost:3001';

export const HJ_ENQUIRY_ADMIN_TOKEN_KEY = 'hj_enquiry_admin_token';

export function getApiBaseUrl() {
  const envUrl = process.env.REACT_APP_CLIENT_MASTER_API_URL;
  if (envUrl && envUrl.trim()) {
    return envUrl.trim().replace(/\/$/, '');
  }
  return `${DEFAULT_MASTER_HOST}${DEFAULT_MASTER_API_PATH}`;
}

export function getHjEnquiryAdminToken() {
  try {
    return sessionStorage.getItem(HJ_ENQUIRY_ADMIN_TOKEN_KEY) || '';
  } catch (_) {
    return '';
  }
}

export function setHjEnquiryAdminToken(token) {
  try {
    if (token) {
      sessionStorage.setItem(HJ_ENQUIRY_ADMIN_TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(HJ_ENQUIRY_ADMIN_TOKEN_KEY);
    }
  } catch (_) {
    /* ignore */
  }
}

export function clearHjEnquiryAdminToken() {
  setHjEnquiryAdminToken('');
}
